import { compose } from 'recompose';
import FilesField from './filesField';
import { withWindowWidth } from '../../../../../utils/enchancers';

const enhance = compose(
  withWindowWidth(),
);
export default enhance(FilesField);
